import {
  SubscriptionsState,
  SubscriptionsMutationTree,
  SubscriptionsActionTree,
  SubscriptionsGetterTree,
  SubscriptionsModule,
} from '@/store/@types/subscriptions';

import { getSubscriptionsProducts } from '@/api/subscriptions';

const state: SubscriptionsState = {
  subscriptionsList: [],
};

const mutations: SubscriptionsMutationTree = {
  SET_SUBSCRIPTIONS_LIST(state, subscriptionsData) {
    state.subscriptionsList = subscriptionsData;
  },
};

const actions: SubscriptionsActionTree = {
  async getSubscriptions({ commit, state }) {
    if (state.subscriptionsList.length) {
      return;
    }
    const subscriptionsData = await getSubscriptionsProducts();

    commit('SET_SUBSCRIPTIONS_LIST', subscriptionsData);
  },
};

const getters: SubscriptionsGetterTree = {
  subscriptionsList: (state) => state.subscriptionsList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as SubscriptionsModule;
